function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("defs", null);

var _ref3 =
/*#__PURE__*/
React.createElement("path", {
  fill: "#67BBB0",
  d: "M0,80C0,35.817,35.817,0,80,0c44.184,0,80,35.817,80,80s-35.816,80-80,80C35.817,160,0,124.183,0,80"
});

var _ref4 =
/*#__PURE__*/
React.createElement("path", {
  fill: "#FFFFFF",
  d: "M116.299,51.744h-5.527V47.5c0-1.519-1.231-2.75-2.75-2.75s-2.75,1.231-2.75,2.75v4.244h-8.482V47.5 c0-1.519-1.231-2.75-2.75-2.75c-1.518,0-2.75,1.231-2.75,2.75v4.244h-8.482V47.5c0-1.519-1.231-2.75-2.75-2.75 s-2.75,1.231-2.75,2.75v4.244h-8.482V47.5c0-1.519-1.231-2.75-2.75-2.75s-2.75,1.231-2.75,2.75v4.244h-8.482V47.5 c0-1.519-1.23-2.75-2.75-2.75c-1.519,0-2.75,1.231-2.75,2.75v4.244H43.7c-1.519,0-2.75,1.231-2.75,2.75V112.5 c0,1.519,1.231,2.75,2.75,2.75h72.599c1.52,0,2.75-1.231,2.75-2.75V54.494C119.049,52.976,117.818,51.744,116.299,51.744  M113.549,109.75H46.45V57.244h2.892v4.161c0,1.518,1.231,2.75,2.75,2.75c1.52,0,2.75-1.232,2.75-2.75v-4.161h8.482v4.161 c0,1.518,1.231,2.75,2.75,2.75s2.75-1.232,2.75-2.75v-4.161h8.482v4.161c0,1.518,1.231,2.75,2.75,2.75s2.75-1.232,2.75-2.75v-4.161 h8.482v4.161c0,1.518,1.232,2.75,2.75,2.75c1.519,0,2.75-1.232,2.75-2.75v-4.161h8.482v4.161c0,1.518,1.231,2.75,2.75,2.75 s2.75-1.232,2.75-2.75v-4.161h2.777V109.75z"
});

var _ref5 =
/*#__PURE__*/
React.createElement("path", {
  fill: "#FFFFFF",
  d: "M67.184,69.331H54.744c-0.966,0-1.75,0.784-1.75,1.75v12.439c0,0.966,0.784,1.75,1.75,1.75h12.439 c0.967,0,1.75-0.784,1.75-1.75V71.081C68.934,70.115,68.15,69.331,67.184,69.331 M65.434,81.771h-8.938v-8.938h8.938V81.771z"
});

var _ref6 =
/*#__PURE__*/
React.createElement("path", {
  fill: "#FFFFFF",
  d: "M86.178,69.331H73.738c-0.965,0-1.75,0.784-1.75,1.75v12.439c0,0.966,0.785,1.75,1.75,1.75h12.439 c0.967,0,1.75-0.784,1.75-1.75V71.081C87.928,70.115,87.145,69.331,86.178,69.331 M84.428,81.771h-8.938v-8.938h8.938V81.771z"
});

var _ref7 =
/*#__PURE__*/
React.createElement("path", {
  fill: "#FFFFFF",
  d: "M67.184,88.325H54.744c-0.966,0-1.75,0.784-1.75,1.75v12.439c0,0.967,0.784,1.75,1.75,1.75h12.439 c0.967,0,1.75-0.783,1.75-1.75V90.075C68.934,89.109,68.15,88.325,67.184,88.325 M65.434,100.765h-8.938v-8.939h8.938V100.765z"
});

var _ref8 =
/*#__PURE__*/
React.createElement("path", {
  fill: "#FFFFFF",
  d: "M86.178,88.325H73.738c-0.965,0-1.75,0.784-1.75,1.75v12.439c0,0.967,0.785,1.75,1.75,1.75h12.439 c0.967,0,1.75-0.783,1.75-1.75V90.075C87.928,89.109,87.145,88.325,86.178,88.325 M84.428,100.765h-8.938v-8.939h8.938V100.765z"
});

var _ref9 =
/*#__PURE__*/
React.createElement("path", {
  fill: "#FFFFFF",
  d: "M105.256,69.331H92.816c-0.965,0-1.75,0.784-1.75,1.75v12.439c0,0.966,0.785,1.75,1.75,1.75h12.439 c0.966,0,1.75-0.784,1.75-1.75V71.081C107.006,70.115,106.222,69.331,105.256,69.331 M103.506,81.771h-8.938v-8.938h8.938V81.771z"
});

var SvgScadenzeAccent = function SvgScadenzeAccent(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, ["svgRef"]);

  return React.createElement("svg", _extends({
    width: 161,
    height: 161,
    viewBox: "-0.043 -0.512 161 161",
    enableBackground: "new -0.043 -0.512 161 161",
    xmlSpace: "preserve",
    ref: svgRef
  }, props), _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgScadenzeAccent, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/scadenze_accent.efb82b48.svg";
export { ForwardRef as ReactComponent };